import { useEffect, useRef, useState } from "react";
import { CloseOutlined } from '@ant-design/icons';
import { ANIMATION_TIME } from '../config';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { useTranslation } from "react-i18next";

const MainCont = ({ message, onClick, initVisible, setInitVisible }) => {
  const [height, setHeight] = useState(0);
  const ref = useRef();
  const [isAnimating, setIsAniamting] = useState(0);
  const { t } = useTranslation();

  const maxHeight = isAnimating ? 0 : height;
  const opacity = maxHeight;

  const _onClick = () => {
    if (isAnimating) {
      return;
    }

    setInitVisible(false);
    setIsAniamting(true);

    setTimeout(() => {
      onClick();
    }, ANIMATION_TIME);
  }

  useEffect(() => {
    const obs = new ResizeObserver(entries => {
      window.requestAnimationFrame(() => {
        setHeight(entries[0].contentRect.bottom + entries[0].contentRect.top)
      });
    });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      className={formatClassname(["animation-cont", initVisible && 'no-transition'])}
      style={{ maxHeight, opacity }}
    >
      <div className="main-cont" ref={ref}>
        <div className="flex-c jus-c flex-1">
          {typeof message === 'string' ? (
            <h5>{t(message)}</h5>
          ) : message}
        </div>
        <CloseOutlined
          onClick={_onClick}
          className="close-icon" />
      </div>
    </div>
  )
};

export default MainCont;
